<template>
  <v-container class="component_main px-6">
    <v-row>
      <v-col>
        <h2>Olá {{ userData.Nome }}</h2>
        <h3>Bem-vindo ao nosso Portal de Serviços!</h3>
      </v-col>
    </v-row>
    <v-row class="d-flex mb-3">
      <!-- justify-space-between -->
      <v-col class="pa-3" cols="12" sm="6" md="4" v-if="hasPermission('autorizador')">
        <v-card outlined height="100%" >
          <v-card-title>
            <v-btn icon @click="$router.push('/autorizacao')">
              <v-icon>fa-bars</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text--primary">
            <h2>Autorizador</h2>
            <div style="font-size:14px" class="mt-5">
              Acompanhe as solicitações<br />do seu dia e seus status.
            </div>
            <div class="d-flex justify-space-between mt-8">
              <div style="font-size:16px">
                {{ autTotalSolicitacoes }}
              </div>
              <div style="color: orange;font-size:16px">
                {{ autEmAnalise }}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div>SOLICITAÇÕES HOJE</div>
              <div style="color: orange">EM ANÁLISE</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- <v-col v-if="!hasPermission('faturamento')" cols="12" sm="6" md="4"></v-col> -->

      <v-col class="pa-3" cols="12" sm="6" md="4" v-if="hasPermission('faturamento')">
        <v-card outlined height="100%">
          <v-card-title>
            <v-btn icon @click="$router.push('/faturamento')">
              <v-icon>fa-file-invoice-dollar</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text--primary">
            <h2>Faturamento</h2>
            <div style="font-size:14px" class="mt-5">
              Acompanhe os cronogramas <br> de faturamento
            </div>
            <div class="d-flex justify-space-between mt-8">
              <div style="color: red;font-size:16px">
                {{ fatTotalComCritica }}
              </div>
              <div style="color: orange;font-size:16px">
                {{ fatTotalAtrasados }}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div style="color: red">COM CRÍTICA</div>
              <div style="color: orange">ATRASADOS</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-3" cols="12" sm="6" md="4" v-if="hasPermission('portal')">
        <v-card outlined height="100%" >
          <v-card-title>
            <v-btn icon @click="$router.push('/notificacoes')">
              <h2>
                <v-badge
                  light
                  :color="newMessagesCount? 'accent' : 'transparent'"
                  class="black--text"
                  :content="newMessagesCount"
                >
                  <v-icon>far fa-bell</v-icon>
                </v-badge>
              </h2>
            </v-btn>
          </v-card-title>
          <v-card-text class="text--primary">
            <h2>Notificações</h2>
            <div two-line v-for="item in listNotifications" :key="item.id" style="cursor: pointer" @click="selectItem(item, 'notification')">
              <v-row class="d-flex justify-space-between">
                <v-col cols="9" class="pr-0" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                  <v-chip
                    v-if="!item.is_readed"
                    class="ma-1"
                    x-small
                    label
                    style="cursor: pointer"
                    color="accent"
                    >Nova
                  </v-chip>
                   <v-tooltip bottom v-if="item.prioridade_alta">
                  <template v-slot:activator="{ on }">
                    <v-icon color="warning" small v-on="on" class="mr-1">fa-bookmark</v-icon>
                  </template>
                  <span
                    style="border: 1px solid #D8DDE6 !important; border-radius: 4px"
                    class="py-1 px-3"
                  >Alta importância</span>
                </v-tooltip>
                  {{ item.nome }}
                </v-col>
                <v-col  cols="3" class="text-right pl-0">{{ item.data_publicacao | formatDate }}</v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
            <small class="mt-3 text--secondary d-flex justify-end">
              DATA DE RECEBIMENTO
            </small>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- <v-col v-if="!hasPermission('recebiveis')" cols="12" sm="6" md="4"></v-col> -->

      <v-col class="display-space" cols="12" sm="6" md="4"  v-if="hasPermission('recebiveis')">
        <v-card outlined height="100%">
          <v-card-title>
            <v-btn icon @click="$router.push('/identificacaonaoperadora')">
              <v-icon>fas fa-key</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text--primary">
            <h2>Identificação na <br> Operadora</h2>
            <div style="font-size:14px" class="mt-5">
              Status de conexão
            </div>
            <div class="d-flex justify-space-between mt-8">
              <div>
              </div>
              <div style="color: red;font-size:16px">
                {{ logins_invalidos }}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div></div>
              <div style="color: red">INVÁLIDOS</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="pa-3" cols="12" sm="6" md="4" v-if="hasPermission('recebiveis')">
        <v-card outlined height="100%">
          <v-card-title>
            <v-btn icon @click="$router.push('/recebiveis/monitorderecebiveis')">
              <v-icon>fa-money-bill-alt</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text--primary">
            <h2>Recebíveis</h2>
            <div style="font-size:14px" class="mt-5">
              Acompanhe os pagamentos <br> recebidos e conciliados
            </div>
            <div class="d-flex justify-space-between mt-8">
              <div>
              </div>
              <div style="color: red;font-size:16px">
                {{intercorrencias}}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div></div>
              <div style="color: red">COM INTERCORRÊNCIAS</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      
      <v-col class="pa-3" cols="12" sm="6" md="4">
        <v-card outlined height="100%" v-if="hasPermission('portal')">
          <v-card-title>
            <v-btn icon @click="$router.push('/documentos')">
              <h2>
                <v-badge
                  light
                  :color="listDocLength? 'accent' : 'transparent'"
                  :content="listDocLength"
                  class="black--text"
                >
                  <v-icon>far fa-file</v-icon>
                </v-badge>
              </h2>
            </v-btn>
          </v-card-title>
          <v-card-text class="text--primary">
            <h2>Documentos</h2>
            <div v-for="(item, index) in listDoc" :key="index" > 
               <v-row class="d-flex justify-space-between">
                <v-col cols="9" class="pr-0" style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                  <v-chip v-if= isNewDocument(item)
                    class="ma-1"
                    x-small
                    label
                    color="accent"
                    >Novo
                  </v-chip>
                  <v-icon color="red darken-2"
                    >far fa-file-pdf</v-icon
                  >
                  {{ item.nome }}
                </v-col>
                <v-col  cols="3" class="text-right pl-0">{{ item.data_publicacao | formatDate }}</v-col>
               </v-row>
              <v-divider></v-divider>
            </div>
            <small class="mt-3 text--secondary d-flex justify-end">
              DATA DE RECEBIMENTO
            </small>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col cols="12" sm="6" md="12"></v-col> -->
    </v-row>
    <Footer />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex"
import Footer from "@/components/common/Footer"
import moment from "moment"
moment.locale('pt-BR')
export default {
  components:{
    Footer,
  },
  data() {
    return {
      opts:{
        grupoEconomico: this.grupoEconomico,
        limit: 2
      },
      showList: true,
      filter: null,
      listAutor: [],
      autTotalSolicitacoes: null,
      autEmAnalise: null,
      identificacao: true,
      recebiveis: true,
      fatTotalAtrasados: 0,
      fatTotalComCritica: 0,
      intercorrencias: null,
      logins_invalidos: 0,
      permissao: []
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  watch: {
    grupoEconomico:{
      deep: true,
      handler(val){
        this.opts.grupoEconomico = val
        this.getCards()
      }
    },
    permissaoBase:{
      deep: true,
      handler(){
        this.getCards()
      }
    },
  },
  computed: {
    ...mapState({
      listNotifications: state => state.notifications.list,
      listDoc: (state) => state.documents.listDoc,
      listDocLength: (state) => state.documents.listDocLength,
      newMessagesCount: state => state.notifications.newMessagesCount,
      permissaoBase: (state) => state.permissions.permissaoBase,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      modulosTitles: (state) => state.permissions.modulosTitles,
      userData: (state) => state.userData.userData,
    }),
    // dashautorizador(){
    //   return (this.userData.UsuarioTradimus)?!!this.permissaoBase.autorizador : !!this.userData.PermissaoAcoes.autorizador
    // },
    // monitorcronogramas(){
    //   return (this.userData.UsuarioTradimus)?!!this.permissaoBase.faturamento : !!this.userData.PermissaoAcoes.faturamento
    // },
    getnotifications(){
      return this.userData.PermissaoAcoes.portal.includes('getnotifications')
    },
    getdocuments(){
      return this.userData.PermissaoAcoes.portal.includes('getdocuments')
    },
  },
  mounted() {
    if(this.grupoEconomico) {
      this.opts.grupoEconomico = this.grupoEconomico,
      this.getCards()
    }
  },
  methods: {
    ...mapActions({
      getDocuments: "documents/getDocuments",
      getDocument: "documents/getDocument",
      selectDocuments: "documents/selectDocuments",
      getNotifications: "notifications/getNotifications",
    }),
    getCards(){
      // if(this.userData.PermissaoAcoes.portal.includes('getdocuments')){
      //   this.getDocuments(opts)
      // }
      // if(this.userData.PermissaoAcoes.portal.includes('getnotifications')){
      //   this.getNotifications(opts)
      // }
      // if (this.userData.UsuarioTradimus) {
      //   if (this.userData.PermissaoAcoes.autorizador && this.permissaoBase.autorizador) {
      //     this.getCardAutorizacao()
      //   }
      //   if (this.userData.PermissaoAcoes.faturamento && this.permissaoBase.faturamento) {
      //     this.getCardFaturamento()
      //   }
      //   if (this.userData.PermissaoAcoes.recebiveis && this.permissaoBase.recebiveis) {
      //     this.getCardRecebiveis()
      //   }
      // } else {
      //   if (this.userData.PermissaoAcoes.autorizador) {
      //     this.getCardAutorizacao()
      //   }
      //   if (this.userData.PermissaoAcoes.faturamento) {
      //     this.getCardFaturamento()
      //   }
      //   if (this.userData.PermissaoAcoes.recebiveis) {
      //     this.getCardRecebiveis()
      //   }
      // }
      let permissaoList = Object.keys(this.permissaoBase)
      let permissaoUserList = Object.keys(this.userData.PermissaoAcoes)
      this.permissao =  this.userData.UsuarioTradimus 
        ?permissaoList.filter(x => x == permissaoUserList.find(el => el == x))
        :permissaoUserList
      for (var typeModule of this.permissao) {
        this.getCardModulos(typeModule)
      }
    },
    getCardModulos(modulo) {
      switch (modulo) {
        case "portal":
           this.getCardPortal(this.opts)
          break
        case "autorizador":
           this.getCardAutorizacao()
          break
        case "faturamento":
          this.getCardFaturamento()
          break
        case "recebiveis":
          this.getCardRecebiveis()
          break
        default:
          break
      }
    },
    getCardPortal(opts) {
      if(this.userData.PermissaoAcoes.portal.includes('getdocuments')){
        this.getDocuments(opts)
      }
      if(this.userData.PermissaoAcoes.portal.includes('getnotifications')){
        this.getNotifications(opts)
      }
    },
    getCardAutorizacao() {
       let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "getcardautorizacao",
            Payload: { grupo_economico: this.grupoEconomico},
            noLoader: true
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
       this.autTotalSolicitacoes = response.total_solicitacoes
        this.autEmAnalise = response.em_analise
      })
    },
    getCardFaturamento() {
       let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "getcardfaturamento",
            Payload: { grupo_economico: this.grupoEconomico},
            noLoader: true
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        this.fatTotalAtrasados = response.total_atrasados
        this.fatTotalComCritica = response.total_com_critica
      })
    },
    getCardRecebiveis() {
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "getdashboardpagamento",
            Payload: { grupo_economico: this.grupoEconomico }
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        this.intercorrencias = response.monitoramento_pagamento.qtd_com_intercorrencias
        this.logins_invalidos = response.cadastro_logins_operadoras.qtd_logins_invalidos
      })
    },
    selectItem(item, action) {
      switch (action) {
        case "notification":
          this.$store.commit('notifications/selectDashboardNotification', item.id)
          this.$router.push("/notificacoes");
          break;
        default:
          break;
      }
    },
    isNewDocument(item){
      let today = new Date().getTime()
      let dataPublicacao = new Date(item.data_publicacao).getTime()
      return (today-dataPublicacao) < 172800000
    },
    hasPermission(modulo) {
      return this.permissao.find(perm => perm == modulo)
    }
  },
};
</script>

<style>
@media(max-width: 960px){
  .display-space {display: none}
}
</style>